import React from 'react';
import SetupLayout from '../../shared/ui/SetupLayout';
import Header from './presenters/Header';
import Body from './presenters/Body';
import { FormControllerProvider } from '../../../../helpers/formManager';
import ProtectedRoute from '../../controllers/ProtectedRoute';

const SetRoomsFromDatePage = ({ className }) => {
  return (
    <ProtectedRoute>
      <FormControllerProvider>
        <SetupLayout
          className={className}
          bgColor="#fff"
          header={<Header />}
          body={<Body />}
        />
      </FormControllerProvider>
    </ProtectedRoute>
  );
};

export default SetRoomsFromDatePage;
